/**
 * @generated SignedSource<<dd1abd93f4bfaa9125ecbf1da5fefa8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlogPostListQuery_Query$variables = {
  userId: string;
};
export type BlogPostListQuery_Query$data = {
  readonly user: {
    readonly " $fragmentSpreads": FragmentRefs<"BlogPostList_User">;
  } | null | undefined;
};
export type BlogPostListQuery_Query = {
  response: BlogPostListQuery_Query$data;
  variables: BlogPostListQuery_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BlogPostListQuery_Query",
    "selections": [
      {
        "alias": "user",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BlogPostList_User"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BlogPostListQuery_Query",
    "selections": [
      {
        "alias": "user",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "self",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                  }
                ],
                "concreteType": "BlogPostConnection",
                "kind": "LinkedField",
                "name": "blogPosts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BlogPostEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BlogPost",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "excerpt",
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Profile",
                                "kind": "LinkedField",
                                "name": "profile",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BlogCategory",
                            "kind": "LinkedField",
                            "name": "blogCategories",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              (v4/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "estimatedReadingTimeMinutes",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "viewsCount",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "blogPosts(first:10)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isMember",
                "storageKey": null
              }
            ],
            "type": "User",
            "abstractKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "79657184921dc96bb6f9e03c71664063",
    "id": null,
    "metadata": {},
    "name": "BlogPostListQuery_Query",
    "operationKind": "query",
    "text": "query BlogPostListQuery_Query(\n  $userId: ID!\n) {\n  user: node(id: $userId) {\n    __typename\n    ...BlogPostList_User\n    id\n  }\n}\n\nfragment BlogPostItem_BlogPost on BlogPost {\n  title\n  excerpt\n  slug\n  blogCategories {\n    name\n    slug\n    id\n  }\n  createdAt\n  estimatedReadingTimeMinutes\n  viewsCount\n  user {\n    name\n    profile {\n      slug\n      id\n    }\n    ...UserAvatarContainer_User\n    id\n  }\n}\n\nfragment BlogPostListItem_BlogPost on BlogPost {\n  status\n  excerpt\n  slug\n  id\n  user {\n    profile {\n      slug\n      id\n    }\n    id\n  }\n  ...BlogPostItem_BlogPost\n}\n\nfragment BlogPostList_User on User {\n  self\n  status\n  blogPosts(first: 10) {\n    edges {\n      node {\n        id\n        ...BlogPostListItem_BlogPost\n      }\n    }\n  }\n  ...user_useIsMember\n}\n\nfragment UserAvatarContainer_User on User {\n  id\n}\n\nfragment user_isMember on User {\n  status\n  isMember\n}\n\nfragment user_useIsMember on User {\n  ...user_isMember\n}\n"
  }
};
})();

(node as any).hash = "7224bbec38dc1f129a9dde6d0eae218d";

export default node;
